require.register("documenteditor/controllers/documenteditorCtrl", function(exports, require, module){
  $0
  
});

